import { ValidationErrorType } from '.';

export const validationMessages: Record<ValidationErrorType, string> = {
  filled: 'skal udfyldes',
  email: 'er ikke en gyldig e-mailadresse'
};



// WEBPACK FOOTER //
// ./src/shared/errors/messages.ts